import { Formatter } from "../../services/formatter/formatter.service";
import { TableTemplateButtons, TableTemplateTag } from "../components/table/table-template.model";
import {
	SentReport,
	SentReportChannel,
	SentReportRecipientType,
} from "../entities/sent-report.model";

export class SentReportRow {
	id: number;
	timestamp: Date;
	channel: SentReportChannel;
	from: string;
	to: string;
	recipientName: string;
	recipientType: SentReportRecipientType;
	status: TableTemplateTag;
	actionsTemplate: TableTemplateButtons;
	entity: SentReport;

	constructor(params: SentReport) {
		this.id = params.id;
		this.timestamp = params.timestamp;
		this.channel = params.channel;
		this.from = params.from ? params.from : "-";
		this.to = params.to ? params.to : "-";
		this.recipientName = params.recipientName ? params.recipientName : "-";
		this.recipientType = params.recipientType;
		this.status = Formatter.setMessageStatus(params.status);
		this.entity = params;
		this.actionsTemplate = templateActions(params.actionFn, params.channel, params.content);
	}
}

const templateActions = (
	actionFn: SentReport["actionFn"],
	channel: SentReportChannel,
	content: string
): TableTemplateButtons => [
	{
		id: "viewReportButton",
		label: "PARTICIPANT.BIOMETRICS.SENT_REPORTS.TABLE.BUTTON_VIEW_REPORT",
		className: "p-button-sm p-button-rounded",
		disabled: ["FAX", "HEALTH_NETWORK"].includes(channel) && content ? false : true,
		onClick: actionFn,
	},
];
